export const PO_BOX_REGEX =
    /^(?! *((#\d+)|((box|bin)[-./ \\]?\d+)|(.*p[. ]? ?(o|0)[-./ ]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+))/i

export const formatPostalCode = (value) => {
    if (!value) return value
    const postalCode = value.replace(/[^\d-]/g, '')
    return postalCode.length < 10 ? postalCode : postalCode.substring(0, 10)
}

export const formatPersonalizedMessage = (message) => {
    if (!message) return message
    return message.length <= 200 ? message : message.substring(0, 200)
}

export const formatAddress = (value) => {
    if (!value) return value
    const address = value.replace(/[^A-Za-z0-9“”‘’'.\- ,!?:;[\](){}"]/g, '')
    return address.length < 50 ? address : address.substring(0, 50)
}

export const formatPhoneNumber = (value) => {
    if (!value) return value
    const phoneNumber = value.replace(/[^\d]/g, '')
    const phoneNumberLength = phoneNumber.length
    if (phoneNumberLength < 4) return phoneNumber
    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
}

// Regex used the same in SFRA
export const validatePhoneNumber = (value) => {
    if (!value) {
        return true
    }
    const naPhone = /^\(?([2-9][0-8][0-9])\)?[ .-]?([2-9][0-9]{2})[ .-]?([0-9]{4})(\s*x[0-9]+)?$/
    return naPhone.test(value.trim())
}

// Regex used the same in SFRA
export const validateEmail = (value) => {
    if (!value || typeof value !== 'string') {
        return true
    }
    const naEmail = /^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/
    return naEmail.test(value.trim())
}

export const formatName = (value) => {
    if (!value) return value
    const name = value.replace(/[^a-zA-Z\-'., ]/g, '')
    return name.length < 50 ? name : name.substring(0, 50)
}

export const formatGcNumber = (value) => {
    if (!value) return value
    return value.length < 16 ? value : value.substring(0, 16)
}

export const formatGcPin = (value) => {
    if (!value) return value
    return value.length < 4 ? value : value.substring(0, 4)
}
